// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fiveBody[data-v-edbd7e92] {\n  width: 100%;\n  padding: 10px 20px;\n  height: calc(100% - 46px);\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
